/*--------------------------------------------------------------------
 * jQuery plugin: customInput()
 * by Maggie Wachs and Scott Jehl, http://www.filamentgroup.com
 * Copyright (c) 2009 Filament Group
 * Dual licensed under the MIT (filamentgroup.com/examples/mit-license.txt) and GPL (filamentgroup.com/examples/gpl-license.txt) licenses.
 * Article: http://www.filamentgroup.com/lab/accessible_custom_designed_checkbox_radio_button_inputs_styled_css_jquery/
 * Usage example below (see comment "Run the script...").
 * ==================================================================
 * Refactored by Swisscom: We sometimes have pre-rendered the custom styles with jsp,
 * so the event `updateState` was not bound. This lead to not beeing able to update
 * the visible state programatically without re-implementing this logic. To has pretty
 * much changed the whole structure of the script, so it will not be easily upgradable.
 --------------------------------------------------------------------*/

jQuery.fn.customInput = function() {
	$(this).each(function(i) {

		var input = $(this),
		    inputId = this.id,
		    inputName = this.name,
		    inputTag = this.tagName.toUpperCase(),
		    inputType = this.type.toLowerCase();

		// can only process input fields with valid id
		if (inputTag != 'INPUT' || !inputId) { return; }
		// check flag to disable any custom input at all
		if (input.hasClass('noCustomInput')) { return; }
		// only works on radio and checkbox input types
		if (inputType != 'radio' && inputType != 'checkbox') { return; }
		// customize each input node only once (singleton check)
		if (input.data('customInput-initialized')) { return; }
		// set the singleton status for this node
		input.data('customInput-initialized', true);

		var parentDivClass = 'custom-' + inputType;

		// get the associated label using the input's id
		// ToDo: will not work if input is inside the label
		var label = $('label[for="' + inputId + '"]');

		// wrap the input and label inside a div
		// it may already be present this way in the html
		if (input.closest("." + parentDivClass).length == 0) {
			$('<div class="custom-'+ inputType +'"></div>')
				.insertBefore(input).append(input, label);
		}

		// bind event to sync the custom UI to the actual state
		input.on('updateState', function() {
			if (!input[0].form) return;
			var isHovered = label.hasClass('hover'),
				isFocused = label.hasClass('focus');
			if (input.is(':checked')) {
				// clear all states for associated input labels
				if (input.is(':radio')) {
					// find all inputs in this set by input's name
					$(input[0].form[inputName]).each(function () {
						if ($(this).attr('id')) {
							$('label[for="' + $(this).attr('id') + '"]')
								.removeClass('checked checkedHover checkedFocus');
						}
					});
				}
				// add `checked` status class
				label.addClass('checked');
				if (isHovered) { label.addClass('checkedHover'); }
				if (isFocused) { label.addClass('checkedFocus'); }
			}
		})
		// trigger the event once
		.trigger('updateState')
		// do updateState on change event
		.change(function() {
			input.trigger('updateState');
		});

		// disable tabbing for readonly items
		if (input.attr('readonly')) {
			input.attr('tabindex', -1);
		}

		// bind hover and focus on input and label
		label.add(input)
		// prevent events on read-only labels from propagating
		// readonly must not be set programatically after init
		.on('click keydown keypress keyup', function(evt) {
			input.trigger('updateState');
			if (input.attr('readonly')) {
				// always allow tab and enter keycodes
				if (!evt.keyCode || evt.keyCode > 13) {
					evt.preventDefault(true);
					evt.stopPropagation(true);
					return false;
				}
			}
		})
		// add `focus` class
		.focus(function() {
			label.addClass('focus');
			input.trigger('updateState');
		})
		// remove `focus` class
		.blur(function() {
			label.removeClass('focus');
			input.trigger('updateState');
		})
		// necessary for browsers that only support :hover
		// pseudo class on link (A) tags (Internet Explorer)
		.hover(
			function() {
				label.addClass('hover');
				input.trigger('updateState');
			},
			function() {
				label.removeClass('hover');
				input.trigger('updateState');
			}
		);

	});
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/vendor/jquery/jquery.customInput.js
// module id = 66
// module chunks = 0